import { useEffect, useState } from 'react'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    scales,
} from 'chart.js'
import { Line } from 'react-chartjs-2'
import { capitalize, setCurrency, setNumberWithPoint } from 'utils/utils'
import { Checkbox } from 'avo-ui'

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, scales)

const Graph = ({ title, name, values }) => {
    const dataCurrent = values?.current_period
    const dataPrevious = values?.previous_period
    const dataPeriod = [
        {
            label: 'currentPeriod',
            data: dataCurrent,
            borderColor: 'rgb(0, 49, 147)',
            backgroundColor: 'rgb(0, 49, 147)',
        },
        {
            label: 'prevPeriod',
            data: dataPrevious?.map((d, i) => {
                return {
                    ...d,
                    xPrev: d?.x,
                    x: dataCurrent[i]?.x,
                }
            }),
            borderColor: 'rgb(232, 107, 145)',
            backgroundColor: 'rgb(232, 107, 145)',
        },
    ]
    const [dataLine, setDataLine] = useState([])
    const [isCurrentGraph, setIsCurrentGraph] = useState(true)
    const [isPreviousGraph, setIsPreviousGraph] = useState(true)
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y: {
                ticks: {
                    callback: (value) => {
                        return name === 'revenue' ? setCurrency(value) : setNumberWithPoint(value?.toFixed(1))
                    },
                },
            },
        },
        plugins: {
            tooltip: {
                yAlign: 'bottom',
                callbacks: {
                    title: (chart) => {
                        if (name === 'revenue') {
                            return setCurrency(chart[0]?.raw?.y)
                        } else {
                            return `${setNumberWithPoint(chart[0]?.raw?.y)} ${capitalize(name)}`
                        }
                    },
                    label: (chart) => {
                        if (chart.dataset.label === 'prevPeriod') {
                            return chart?.raw?.xPrev
                        } else {
                            return chart?.raw?.x
                        }
                    },
                },
            },
        },
    }

    const checkedGraph = (isChecked, name) => {
        if (name === 'current-period') {
            setIsCurrentGraph(isChecked)
        } else {
            setIsPreviousGraph(isChecked)
        }
    }

    useEffect(() => {
        if (isCurrentGraph && isPreviousGraph) {
            setDataLine(dataPeriod)
        } else if (isCurrentGraph) {
            setDataLine(dataPeriod.splice(0, 1))
        } else if (isPreviousGraph) {
            setDataLine(dataPeriod.splice(1, 1))
        } else {
            setDataLine(dataPeriod.map(() => []))
        }
    }, [isCurrentGraph, isPreviousGraph, values])

    return (
        <div className={'flex flex-col'}>
            <div className={'flex space-x-8 px-4 py-6 bg-neutral-5'}>
                <Checkbox
                    label={
                        <div className={'flex items-center space-x-2'}>
                            <div className={'bg-blue-90 p-1.5 rounded-full'}></div>
                            <p>Periode Saat Ini</p>
                        </div>
                    }
                    name={'current-period'}
                    value={'current-period'}
                    checked={isCurrentGraph}
                    onChange={({ name, checked }) => checkedGraph(checked, name)}
                />
                <Checkbox
                    label={
                        <div className={'flex items-center space-x-2'}>
                            <div className={'bg-pink-40 p-1.5 rounded-full'}></div>
                            <p>Periode Sebelumnya</p>
                        </div>
                    }
                    name={'previous-period'}
                    value={'previous-period'}
                    checked={isPreviousGraph}
                    onChange={({ name, checked }) => checkedGraph(checked, name)}
                />
            </div>
            <div className={'flex w-full h-[400px]'}>
                <div className={'flex flex-col basis-1/12 justify-between bg-blue-5 text-base font-bold'}>
                    <div />
                    <p className={'-rotate-90 text-center'}>{title}</p>
                    <p className={'text-center p-4 bg-blue-20'}>Tanggal</p>
                </div>
                <div className={'pl-8 py-4 basis-11/12'}>
                    <Line options={options} data={{ datasets: dataLine }} />
                </div>
            </div>
        </div>
    )
}

export default Graph
